module.exports = __webpack_public_path__ + "img/bg_3.2f322ec5.png";